import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSlug from 'rehype-slug';
import remarkGfm from 'remark-gfm';
import { MarkdownHeading } from './heading';
import { MarkdownHr } from './hr';
import { MarkdownImage } from './image';
import { MarkdownLink } from './link';
import { MarkdownList } from './list';
import { MarkdownListNumeric } from './list-numeric';
import { MarkdownQuote } from './quote';
import { MarkdownP, MarkdownText } from './text';

export {
  MarkdownHeading,
  MarkdownHr,
  MarkdownImage,
  MarkdownLink,
  MarkdownList,
  MarkdownListNumeric,
  MarkdownQuote,
  MarkdownText,
};

interface Props {
  data: string;
  components?: {
    h1?: React.FC;
    h2?: React.FC;
    h3?: React.FC;
    img?: React.FC;
    text?: React.FC;
    a?: React.FC;
    hr?: React.FC;
    ul?: React.FC;
    ol?: React.FC;
    blockquote?: React.FC;
    code?: React.FC;
  };
}

export const Markdown = ({ data, components }: Props) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw, rehypeSlug]}
      components={{
        h1: ({ ...props }) => <MarkdownHeading {...props} />,
        h2: ({ ...props }) => <MarkdownHeading {...props} />,
        h3: ({ ...props }) => <MarkdownHeading {...props} />,
        img: ({ ...props }) => <MarkdownImage {...props} />,
        text: ({ ...props }) => <MarkdownText blog {...props} />,
        p: ({ ...props }) => <MarkdownP {...props} />,
        a: ({ ...props }) => <MarkdownLink {...props} />,
        hr: ({ ...props }) => <MarkdownHr {...props} />,
        ul: ({ ...props }) => <MarkdownList {...props} />,
        ol: ({ ...props }) => <MarkdownListNumeric {...props} />,
        blockquote: ({ ...props }) => <MarkdownQuote {...props} />,
        ...components,
      }}
    >
      {data}
    </ReactMarkdown>
  );
};
